import React from 'react'
import ReactDOM from 'react-dom'
import isError from 'utils/isError'
import controller from 'controller'
import { DialogComponent } from 'components/Common/Dialog'
import { translation as t } from 'consts'

const errorWrapper = document.getElementById('error-wrapper')
const root = document.getElementById('root')

const props = {
  onDismiss: () => window.location.reload(),
  dialog: {
    type: 'alert',
    title: {
      key: 'bms.app.dialog.error.title'
    },
    content: {
      key: 'bms.app.dialog.error.content'
    }
  }
}

export default [
  async function({ props, controller, translator }) {
    const { tags = [], customError = props.error, error, ...rest } = props
    const currentState = controller.getState() || {}

    if (
      !currentState.app ||
      (currentState.app && !currentState.app.user) ||
      (currentState.app &&
        currentState.app.user &&
        !currentState.app.user.locale)
    ) {
      const URL = process.env.REACT_APP_TRANSLATOR_URL || '/translator'
      await translator.bootstrap(URL, t.system, 'en', t.namespaces, 'Unknown')
    }
  },
  function() {
    ReactDOM.render(<DialogComponent {...props} />, errorWrapper)
    controller.getSignal = () => () => {} // prevents websocket calls
    ReactDOM.unmountComponentAtNode(root)
  }
]



// WEBPACK FOOTER //
// ./src/modules/App/chains/handleError.js